import { render, staticRenderFns } from "./PeriodDuration.vue?vue&type=template&id=5ada84ae&scoped=true&"
import script from "./PeriodDuration.vue?vue&type=script&lang=js&"
export * from "./PeriodDuration.vue?vue&type=script&lang=js&"
import style0 from "./PeriodDuration.vue?vue&type=style&index=0&id=5ada84ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ada84ae",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ada84ae')) {
      api.createRecord('5ada84ae', component.options)
    } else {
      api.reload('5ada84ae', component.options)
    }
    module.hot.accept("./PeriodDuration.vue?vue&type=template&id=5ada84ae&scoped=true&", function () {
      api.rerender('5ada84ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/progressbar/LeaderBoard/components/PeriodDuration.vue"
export default component.exports